import { ParamListBase, StackNavigationState, TypedNavigator } from '@react-navigation/core';
import { StackNavigationEventMap, StackNavigationOptions } from '@react-navigation/stack';

import { StressBreathingIndex, StressBreathingNew, StressBreathingShow } from './screens/index';
import { StressBreathingStackParamList } from './types/navigation';

export function registerStressBreathingScreens<T extends ParamListBase>(
  stack: TypedNavigator<
    T,
    StackNavigationState<StressBreathingStackParamList>,
    StackNavigationOptions,
    StackNavigationEventMap,
    any // eslint-disable-line
  >,
) {
  const Stack = stack as TypedNavigator<
    StressBreathingStackParamList,
    StackNavigationState<StressBreathingStackParamList>,
    StackNavigationOptions,
    StackNavigationEventMap,
    any // eslint-disable-line
  >;
  return (
    <>
      <Stack.Screen name="StressBreathingIndex" component={StressBreathingIndex} />
      <Stack.Screen name="StressBreathingShow" component={StressBreathingShow} />
      <Stack.Screen name="StressBreathingNew" component={StressBreathingNew} />
    </>
  );
}
